import { apiClient } from './client'
import type { ApiResponse } from './client'
import type { AddAuthConnectionRequest, AuthConnectionDto } from '@/types/authConnections'

export const authConnectionsApi = {
  // Create a new auth connection
  createConnection: (
    clientCompanyId: string,
    authOrgId: string,
    payload: AddAuthConnectionRequest,
    signal?: AbortSignal
  ): Promise<ApiResponse<AuthConnectionDto>> => {
    return apiClient.post(
      `/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections`,
      payload,
      { signal }
    )
  },

  // List all connections for an auth organization
  listConnections: (
    clientCompanyId: string,
    authOrgId: string,
    signal?: AbortSignal
  ): Promise<ApiResponse<AuthConnectionDto[]>> => {
    return apiClient.get(
      `/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections`,
      { signal }
    )
  },

  // Get a specific connection
  getConnection: (
    clientCompanyId: string,
    authOrgId: string,
    connectionId: string,
    signal?: AbortSignal
  ): Promise<ApiResponse<AuthConnectionDto>> => {
    return apiClient.get(
      `/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections/${connectionId}`,
      { signal }
    )
  },

  // Enable a connection
  enableConnection: (
    clientCompanyId: string,
    authOrgId: string,
    connectionId: string,
    signal?: AbortSignal
  ): Promise<ApiResponse<void>> => {
    return apiClient.put(
      `/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections/${connectionId}/Enable`,
      {},
      { signal }
    )
  },

  // Disable a connection
  disableConnection: (
    clientCompanyId: string,
    authOrgId: string,
    connectionId: string,
    signal?: AbortSignal
  ): Promise<ApiResponse<void>> => {
    return apiClient.put(
      `/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections/${connectionId}/Disable`,
      {},
      { signal }
    )
  },

  // Delete a connection
  deleteConnection: (
    clientCompanyId: string,
    authOrgId: string,
    connectionId: string,
    signal?: AbortSignal
  ): Promise<ApiResponse<void>> => {
    return apiClient.delete(
      `/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections/${connectionId}`,
      { signal }
    )
  }
}
